import styled, { css } from 'styled-components';
import { TableHeader } from '../TableHeader/TableHeader';
export var ActionsHeader = styled(TableHeader).withConfig({
  displayName: "styled__ActionsHeader",
  componentId: "sc-1o0di6h-0"
})(function (_ref) {
  var space = _ref.theme.space;
  return css(["padding:0 ", "px;"], space.xxs);
});